import { PencilBoxMultipleIcon } from './PencilBoxMultipleIcon';

/**
 * author: Michael Irigoyen
 * id 3E7031C9-56EE-458C-BE57-B1A737E09998
 * name pencil-box-multiple
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-box-multiple.svg
 * tags
 * - Edit / Modify 
 */
export const LibraryEditIcon = PencilBoxMultipleIcon;
export default LibraryEditIcon